// import React, { useRef } from "react";
// import { FaChevronLeft, FaChevronRight, FaHeart } from "react-icons/fa";
// import "./TopUniqueProperties.css";

// const properties = [
//   {
//     name: "Domki Wierszyki Shelters",
//     location: "Poland, Zakopane",
//     rating: 9.6,
//     reviews: 89,
//     status: "Exceptional",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/square600/280950287.webp?k=d5b9f77442fa93b93c86a720abebfe39a3f9532d4efa6a9cefa231a2ded6bd95&o=",
//   },
//   {
//     name: "Ranczo w Dolinie",
//     location: "Poland, Kiszkowo",
//     rating: 9.6,
//     reviews: 139,
//     status: "Exceptional",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/square600/280950287.webp?k=d5b9f77442fa93b93c86a720abebfe39a3f9532d4efa6a9cefa231a2ded6bd95&o=",
//   },
//   {
//     name: "Tiny House Dreischwesternherz",
//     location: "Germany, Trier",
//     rating: 9.5,
//     reviews: 134,
//     status: "Exceptional",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/square600/280950287.webp?k=d5b9f77442fa93b93c86a720abebfe39a3f9532d4efa6a9cefa231a2ded6bd95&o=",
//   },
//   {
//     name: "Das rote Haus hinterm Deich",
//     location: "Germany, Simonsberg",
//     rating: 9.6,
//     reviews: 41,
//     status: "Exceptional",
//     image:
//       "https://cf.bstatic.com/xdata/images/hotel/square600/280950287.webp?k=d5b9f77442fa93b93c86a720abebfe39a3f9532d4efa6a9cefa231a2ded6bd95&o=",
//   },
// ];

// const TopUniqueProperties = () => {
//   const scrollRef = useRef(null);

//   const scroll = (dir) => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({
//         left: dir === "left" ? -350 : 350,
//         behavior: "smooth",
//       });
//     }
//   };

//   return (
//     <div className="unique-properties-container">
//       <h2>Stay at our top unique properties</h2>
//       <p className="subtitle">
//         From castles and villas to boats and igloos, we have it all
//       </p>

//       <div className="unique-scroll-wrapper">
//         <button className="scroll-btn left" onClick={() => scroll("left")}>
//           <FaChevronLeft />
//         </button>

//         <div className="unique-properties" ref={scrollRef}>
//           {properties.map((p, i) => (
//             <div className="unique-card" key={i}>
//               <div className="image-box">
//                 <img src={p.image} alt={p.name} />
//                 <button className="heart-btn">
//                   <FaHeart />
//                 </button>
//               </div>
//               <div className="property-info1">
//                 <h3>{p.name}</h3>
//                 <p className="location">{p.location}</p>
//                 <div className="rating">
//                   <span className="rating-badge">{p.rating}</span>
//                   <span className="status">{p.status}</span>
//                   <span className="reviews">{p.reviews} reviews</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <button className="scroll-btn right" onClick={() => scroll("right")}>
//           <FaChevronRight />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default TopUniqueProperties;
















import React, { useRef, useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight, FaHeart } from "react-icons/fa";
import "./TopUniqueProperties.css";

const TopUniqueProperties = () => {
  const scrollRef = useRef(null);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -350 : 350,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const res = await fetch(
          "https://striking-dedication-production.up.railway.app/api/v1/public/properties",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        console.log("Fetched properties:", data.data.properties);
          const approvedProperties = (data.data.properties || []).filter(
          (p) => p.status?.toLowerCase() === "approved"
        );
        setProperties(approvedProperties || []);
      } catch (error) {
        console.error("Error fetching properties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  return (
    <div className="unique-properties-container">
      <h2>Stay at our top unique properties</h2>
      <p className="subtitle">
        From castles and villas to boats and igloos, we have it all
      </p>

      {loading ? (
        <p className="loading-text">Loading properties...</p>
      ) : (
        <div className="unique-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scroll("left")}>
            <FaChevronLeft />
          </button>

          <div className="unique-properties" ref={scrollRef}>
            {properties.map((p, i) => (
              <div className="unique-card" key={i}>
                <div className="image-box">
                  <img
                    src={
                      p.images?.[0] ||
                      "https://via.placeholder.com/400x300?text=No+Image"
                    }
                    alt={p.propertyName || "Property"}
                  />
                  <button className="heart-btn">
                    <FaHeart />
                  </button>
                </div>
                <div className="property-info1">
                  <h3>{p.propertyName}</h3>
                  <p className="location">
                   {p.address} {p.city}, {p.country} {p.zipCode}
                  </p>
                  <div className="rating">
                    <span className="rating-badge">{p.rating || "9.5"}</span>
                    <span className="status">
                      {p.rating >= 9 ? "Exceptional" : "Excellent"}
                    </span>
                    <span className="reviews">
                      {p.reviewsCount || 50} reviews
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="scroll-btn right" onClick={() => scroll("right")}>
            <FaChevronRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default TopUniqueProperties;
